module.exports = __webpack_public_path__ + "static/media/ic_zoom_in.cb556cc0.svg";